import React from "react";
import { useLocation } from "react-router-dom";
import { getLastSegment } from "Lib/pathHelpers";
import navStyles from "Styles/components/navigation-wrapper.module.css";
import classNames from "classnames";
import PaginationBar from "./PaginationBar";
import { useProgress } from "Contexts/ProgressContext";
import { useSession } from "Contexts/SessionContext";
import useSegment from "Hooks/useSegment";

const NavigationWrapper = () => {
  const pagesWithoutNavigation = ["/", "complete", "404"];
  const segment = useSegment();
  const { isLoading: sessionLoading } = useSession();

  const { currentNavIndex, navIndexes, currentProgress } = useProgress();

  const navigationWrapperClassNames = classNames(
    navStyles["navigationWrapper"],
  );

  const location = useLocation();

  if (pagesWithoutNavigation.includes(segment) || sessionLoading) {
    return null;
  } else {
    return (
      <div
        className={navigationWrapperClassNames}
        style={{ marginTop: "auto", display: "flex" }}
      >
        {currentNavIndex && (
          <PaginationBar
            currentPage={getLastSegment(location.pathname)}
            navigationData={navIndexes}
            progress={currentProgress}
          />
        )}
        {/* <div
          className={navStyles.formControlsButtons}
          style={{ marginLeft: "auto" }}
        >
          <PrevPageBtn
            disabled={prevPage === null}
            to={getLinkTarget(prevPage) || "/"}
            style={{ marginRight: "0.5rem" }}
          />
          <NextPageBtn
            disabled={nextPage === null || !isCurrentPageComplete()}
            to={getLinkTarget(nextPage) || "/"}
          />
        </div> */}
      </div>
    );
  }
};

export default NavigationWrapper;
